// based on: https://github.com/facebook/lexical/blob/main/packages/lexical-playground/src/utils/url.ts
const SUPPORTED_URL_PROTOCOLS = new Set([
    "http:",
    "https:",
    "mailto:",
    "sms:",
    "tel:"
]);
export function sanitizeUrl(url) {
    try {
        const parsedUrl = new URL(url);
        if (!SUPPORTED_URL_PROTOCOLS.has(parsedUrl.protocol)) {
            return "about:blank";
        }
    }
    catch (_a) {
        return url;
    }
    return url;
}
export function validateUrl(url) {
    // Simple url test to just check if url starts with http or www
    // or if url ends with `.[something]`
    if (url.startsWith("http") || url.startsWith("www"))
        return true;
    if (/\.[a-zA-Z]+$/.test(url))
        return true;
    return false;
}
